// Maps a CommissionType.name (as stored in DB and exposed by the API) to a
// short display symbol shown next to the commission value in listings, detail
// pages and reports. The select input in the form keeps the full label so the
// user can pick explicitly ("Pourcentage" / "Montant fixe" / "Mois de loyer").
export const commissionTypeSymbol = (name) => {
  switch (name) {
    case "Pourcentage":
      return "%";
    case "Montant fixe":
      return "€";
    case "Mois de loyer":
      return "mois";
    default:
      return name ?? "";
  }
};
